import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SOCIALS, IMAGES } from "@/constants/site";

const EASE = [0.22, 1, 0.36, 1];

const CHANNELS = [
  { num: "01", name: "YouTube", note: "Full-length talks, teachings & table conversations", url: SOCIALS.youtube, testId: "watch-link-youtube" },
  { num: "02", name: "TikTok", note: "Daily candor, quick pulls & word for the timeline", url: SOCIALS.tiktok, testId: "watch-link-tiktok" },
  { num: "03", name: "Facebook", note: "Community, livestreams & the long way home", url: SOCIALS.facebook, testId: "watch-link-facebook" },
];

export default function Watch() {
  return (
    <section id="watch" data-testid="watch-section" className="relative overflow-hidden bg-[#1E1A18] py-28 md:py-40">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={IMAGES.candle} alt="" className="h-full w-full object-cover opacity-[0.12]" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1E1A18] via-transparent to-[#1E1A18]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-[#D49A36] md:text-xs"
        >
          Watch
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="max-w-3xl font-display text-4xl font-medium leading-[1.02] tracking-tight text-[#F2EFE9] md:text-6xl"
        >
          Sit a while. <span className="italic text-[#D49A36]">The work is on the record.</span>
        </motion.h2>

        <div className="mt-16 md:mt-24">
          {CHANNELS.map((channel, i) => (
            <motion.a
              key={channel.testId}
              data-testid={channel.testId}
              href={channel.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: EASE }}
              className="group flex items-center justify-between gap-6 border-t border-[#D49A36]/15 py-8 transition-colors duration-500 last:border-b hover:bg-[#D49A36]/[0.04] md:py-12"
            >
              <div className="flex items-baseline gap-6 md:gap-12">
                <span className="font-display text-lg italic text-[#8C382A] md:text-xl">{channel.num}</span>
                <div>
                  <h3 className="font-display text-4xl font-medium tracking-tight text-[#F2EFE9] transition-all duration-500 group-hover:translate-x-3 group-hover:text-[#D49A36] md:text-7xl">
                    {channel.name}
                  </h3>
                  <p className="mt-2 text-sm text-[#DCD8D3]/80 transition-transform duration-500 group-hover:translate-x-3 md:text-base">
                    {channel.note}
                  </p>
                </div>
              </div>
              <ArrowUpRight
                className="h-8 w-8 shrink-0 text-[#DCD8D3]/40 transition-all duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#D49A36] md:h-12 md:w-12"
                strokeWidth={1.25}
              />
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
